var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-chart"},[_c('div',{staticClass:"lc1-header"},[_vm._v("垃圾分类排行")]),_vm._v(" "),_c('dv-decoration-2',{staticStyle:{"height":"10px"}}),_vm._v(" "),_c('check-date',{on:{"getDate":_vm.getDate}}),_vm._v(" "),_c('scroll-board',{attrs:{"dateValue":_vm.dateValue}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b882a16","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/datav/LeftChart.vue
// module id = null
// module chunks = 